export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const API_KEY = process.env.REACT_APP_API_KEY;
export const TELECONSULT_URL = process.env.REACT_APP_TELECONSULT_URL;

export const getAxiosConfig = (token = '') => {
  const authToken = token ? token : sessionStorage.getItem('authToken');
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    "Accept": "application/json",
  };

  if (authToken) {
    headers["Authorization"] = `Bearer ${authToken}`;
  }

  if (API_KEY) {
    headers["X-API-Key"] = API_KEY;
  }

  return { headers };
};
